import * as React from "react";

const SvgRuleFilled = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 3C3.89543 3 3 3.89543 3 5V15C3 16.1046 3.89543 17 5 17H15C16.1046 17 17 16.1046 17 15V5C17 3.89543 16.1046 3 15 3H5ZM0 4.75C0 4.33579 0.335786 4 0.75 4C1.16421 4 1.5 4.33579 1.5 4.75V15.25C1.5 15.6642 1.16421 16 0.75 16C0.335786 16 0 15.6642 0 15.25V4.75ZM18.5 4.75C18.5 4.33579 18.8358 4 19.25 4C19.6642 4 20 4.33579 20 4.75V15.25C20 15.6642 19.6642 16 19.25 16C18.8358 16 18.5 15.6642 18.5 15.25V4.75Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 6.75C6 6.33579 6.33579 6 6.75 6H13.25C13.6642 6 14 6.33579 14 6.75C14 7.16421 13.6642 7.5 13.25 7.5H6.75C6.33579 7.5 6 7.16421 6 6.75ZM6 9.94995C6 9.53574 6.33579 9.19995 6.75 9.19995H13.25C13.6642 9.19995 14 9.53574 14 9.94995C14 10.3642 13.6642 10.7 13.25 10.7H6.75C6.33579 10.7 6 10.3642 6 9.94995ZM6.75 12.3999C6.33579 12.3999 6 12.7357 6 13.1499C6 13.5641 6.33579 13.8999 6.75 13.8999H13.25C13.6642 13.8999 14 13.5641 14 13.1499C14 12.7357 13.6642 12.3999 13.25 12.3999H6.75Z"
      fill="#333333"
    />
  </svg>
);

export default SvgRuleFilled;
